export default __webpack_public_path__ + "assets/images/d4998dfbf17cdc0c0389bef65949d246.jpg";